var exports = {
  "z": "HighlightedText__WKM1D-",
  "B": "Wrap__-YDpSK",
};

module.exports = exports;
